import BaseCollectionService from "./base.collection.service";

export default class SearchService extends BaseCollectionService {
  constructor(collection: string) {
    super(collection);
  }
}
